import axios, { AxiosInstance } from 'axios';
import { authService } from './authService';
import { apiConfig } from '../config/apiConfig';
import type { GeoChatRequest, GeoChatResponse } from '../components/geospatial/types';

class GeoChatService {
  private ax: AxiosInstance;

  constructor() {
    this.ax = axios.create({
      baseURL: apiConfig.baseUrl,
      timeout: 45000,
      headers: { 'Content-Type': 'application/json' },
    });

    this.ax.interceptors.request.use(async (config) => {
      const base = (config.baseURL || '').toString();
      if (base.includes('localhost:3001')) return config;
      try {
        const token = await authService.getAccessToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
      } catch {
        // allow request to fail naturally
      }
      return config;
    });
  }

  async query(request: GeoChatRequest): Promise<GeoChatResponse> {
    const res = await this.ax.post<GeoChatResponse>('/api/spatial/chat', request);
    return res.data;
  }
}

export const geoChatService = new GeoChatService();
